import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const notificationsFeatureKey = 'notifications';

export interface NotificationState {
  loadNotifications: any;
  loadNotificationsResponse: any;
  loadNotificationsFailure: Error | any;
}

export const initialState: NotificationState = {
  loadNotifications: undefined,
  loadNotificationsResponse: undefined,
  loadNotificationsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadNotifications, (state, action) => ({
    ...state,
    loadNotifications: action.request
  })),
  on(actions.loadNotificationsSuccess, (state, action) => ({
    ...state,
    loadNotifications: action.response
  })),
  on(actions.loadNotificationsFailure, (state, action) => ({
    ...state,
    loadNotifications: action.error
  }))
);

export const getNotifications = (state: NotificationState) => state.loadNotificationsResponse;
